import Icon from '../../../Assets/Icon/CustomIcon';
import { Box, Typography } from '@mui/material';
import Global from '../../../Services/Common/Global';

export default function CheckList(props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        width: '100%',
        flexDirection: 'column',
      }}
    >
      {Object.entries(props.rowData2 || {}).map(([workType, items], idx) => (
        <Box
          key={idx}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography sx={{ fontWeight: 'bold' }}>작업종류</Typography>
            <Typography sx={{ fontWeight: 'bold', color: '#ff6200ff' }}>
              {workType}
            </Typography>
          </Box>

          {items.map((item, subIdx) => (
            <Box
              key={subIdx}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }}>
                {item.WORK_TYPE_DTL_NM}
              </Typography>
              <Typography
                sx={{
                  color: item.ITEM_CHECK === '0' ? '#575EE5' : '#7B7B7B',
                }}
              >
                {item.ITEM_CHECK === '0' ? '확인' : '해당없음'}
              </Typography>
            </Box>
          ))}
        </Box>
      ))}

      {props.rowData1.GUBUN === '요청' && (
        <button
          onClick={() => props.setIsChecked(!props.isChecked)}
          style={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
            justifyItems: 'center',
            border: 'none',
            backgroundColor: 'transparent',
          }}
        >
          <Icon.CircleCheck
            width={30}
            height={30}
            color={props.isChecked ? '#57B84D' : '#B5B1B1'}
          />
          <Typography
            sx={{
              color: props.isChecked ? '#3A3A3A' : '#B5B1B1',
              fontWeight: props.isChecked ? 'bold' : 'normal',
              transition: 'color 0.3s ease, font-weight 0.3s ease',
            }}
          >
            작업별 사전체크 항목을 모두 확인했습니다.
          </Typography>
        </button>
      )}

      {props.rowData1.DEP_SIGN === 'Y' && (
        <>
          <hr
            style={{
              border: 'none',
              borderTop: '1px solid #F8EFEF',
              margin: '4px 0',
            }}
          />
          <Typography sx={{ fontWeight: 'bold' }}>작업관리 부서</Typography>
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }}>확인자</Typography>
              <Typography
                sx={{
                  color: '#F57526',
                  fontWeight: 'bold',
                }}
              >
                {props.rowData1.DEP_HEAD_NAME}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyItems: 'center',
                  width: '100%',
                }}
              >
                <Typography sx={{}}> {props.rowData1.DEP_NM_LAST}</Typography>
                <Typography sx={{}}>
                  {props.rowData1.DEP_HEAD_POSITION}
                </Typography>
              </Box>
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                (인)
              </Typography>
              {props.rowData1?.DEP_SIGN_PATH && (
                <img
                  src={`${Global.file.useUrl}files/${props.rowData1.DEP_SIGN_PATH}`}
                  alt="결재승인자 사인"
                  style={{
                    width: '100px',
                    height: 'auto',
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                />
              )}
            </Box>
          </Box>
        </>
      )}

      {props.rowData1.SM_SIGN === 'Y' && (
        <>
          <hr
            style={{
              border: 'none',
              borderTop: '1px solid #F8EFEF',
              margin: '4px 0',
            }}
          />
          <Typography sx={{ fontWeight: 'bold' }}>허가관리 부서</Typography>
          <Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }}>확인자</Typography>
              <Typography
                sx={{
                  color: '#F57526',
                  fontWeight: 'bold',
                }}
              >
                {props.rowData1.SM_NAME}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyItems: 'center',
                  width: '100%',
                }}
              >
                <Typography sx={{}}> {props.rowData1.DEP_NM_LAST}</Typography>
                <Typography sx={{}}>{props.rowData1.SM_POSITION}</Typography>
              </Box>
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                (인)
              </Typography>
              {props.rowData1?.SM_SIGN_PATH && (
                <img
                  src={`${Global.file.useUrl}files/${props.rowData1.SM_SIGN_PATH}`}
                  alt="안전관리자 사인"
                  style={{
                    width: '100px',
                    height: 'auto',
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                  }}
                />
              )}
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
